import List from './List';
import Detail from '../../../vendor/Ry/Airline/Resdit/Detail';

const Components = {
    List : List,
    Detail : Detail
}

export default Components;
